<template>
    <div>
        <label :id="id"
               class="block text-sm leading-5 text-gray-700"
               :class="{ 'font-medium': ! this.bold, 'font-bold': this.bold }"
               v-html="label"
               v-if="label"
        ></label>
        <div class="mt-1 relative rounded-md shadow-sm">
            <div class="flex items-center border border-gray-300 rounded-md text-gray-400 px-2 focus-within:shadow-outline-blue"
                 :class="{ 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus-within:shadow-outline-red': error }"
            >
                <button class="focus:outline-none hover:text-primary-600"
                        @click="decrement"
                >
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 12H6"></path>
                    </svg>
                </button>

                <div class="relative w-full">
                    <input type="text"
                           :id="id"
                           :name="name"
                           class="form-input block w-full sm:text-sm sm:leading-5 border-0 focus:shadow-none text-center text-black"
                           :class="{ 'pr-10': error }"
                           :value="value"
                           :required="required"
                           readonly
                    />

                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                         v-if="error"
                    >
                        <svg class="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                        </svg>
                    </div>
                </div>

                <button class="focus:outline-none hover:text-primary-600"
                        @click="increment"
                >
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                    </svg>
                </button>
            </div>
        </div>
        <p class="mt-1 text-xs text-red-600">
            {{ error }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
        },

        id: {
            type: String,
        },

        name: {
            type: String,
        },

        error: {
            type: String,
        },

        required: {
            type: Boolean,
            default: false
        },

        value: {
            type: Number,
            required: true,
        },

        max: {
            type: Number,
            default: null
        },

        bold: {
            type: Boolean,
            default: false,
        }
    },

    methods: {
        decrement() {
            if (this.value === 0) return false;

            this.$emit('input', this.value - 1);
        },

        increment() {
            if (this.value === this.max) return false;

            this.$emit('input', this.value + 1);
        }
    }
}
</script>
